import { NavLink } from "react-router-dom";
import { Home, MessageSquare, Users, Smartphone, Settings } from "lucide-react";
import { useLang } from "@/App";

const TABS = [
    { to: "/", key: "home", icon: Home, testid: "tab-home" },
    { to: "/chat", key: "chat", icon: MessageSquare, testid: "tab-chat" },
    { to: "/characters", key: "characters", icon: Users, testid: "tab-characters" },
    { to: "/android", key: "android", icon: Smartphone, testid: "tab-android" },
];

export default function MobileTabBar() {
    const { t } = useLang();
    return (
        <nav
            data-testid="mobile-tabbar"
            className="md:hidden fixed bottom-0 left-0 right-0 z-50 border-t border-[#212b45] bg-[#080a12]/90 backdrop-blur-xl"
            style={{ paddingBottom: "env(safe-area-inset-bottom, 0px)" }}
        >
            <div className="grid grid-cols-5">
                {TABS.map((tab) => {
                    const Icon = tab.icon;
                    return (
                        <NavLink
                            key={tab.to}
                            to={tab.to}
                            end={tab.to === "/"}
                            data-testid={tab.testid}
                            className={({ isActive }) =>
                                `flex flex-col items-center gap-1 py-2.5 transition-colors ${
                                    isActive ? "text-[#d7ff35]" : "text-slate-500"
                                }`
                            }
                        >
                            {({ isActive }) => (
                                <>
                                    <span className={`relative grid place-items-center w-11 h-7 rounded-full transition-colors ${isActive ? "bg-[#d7ff35]/15" : ""}`}>
                                        <Icon size={19} />
                                    </span>
                                    <span className="font-mono2 text-[8px] tracking-[0.12em] uppercase">{t.nav[tab.key]}</span>
                                </>
                            )}
                        </NavLink>
                    );
                })}
                <NavLink
                    to="/settings"
                    data-testid="tab-settings"
                    aria-label={t.nav.settings}
                    className={({ isActive }) =>
                        `flex flex-col items-center gap-1 py-2.5 transition-colors ${isActive ? "text-[#d7ff35]" : "text-slate-500"}`
                    }
                >
                    {({ isActive }) => (
                        <>
                            <span className={`relative grid place-items-center w-11 h-7 rounded-full transition-colors ${isActive ? "bg-[#d7ff35]/15" : ""}`}>
                                <Settings size={19} />
                            </span>
                            <span className="font-mono2 text-[8px] tracking-[0.12em] uppercase">···</span>
                        </>
                    )}
                </NavLink>
            </div>
        </nav>
    );
}
